import { connect } from 'react-redux';

import { State as StoreState } from 'store/state';

import Component from './component';
import { Props } from './types';

const mapStateToProps = (state: StoreState, ownProps?: Props): object => {
    return {
        state: {
            profile: state.user.profile,
        },
    };
};

Component.defaultProps = {};
export default connect(mapStateToProps)(Component);
